export default function initTabsAutoScroll(selector) {
    const tabs = document.querySelectorAll(selector);

    if (tabs.length) {
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                tab.scrollIntoView({inline: 'center', block: 'nearest', behavior: 'smooth'});
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/js/tabsAutoScroll.js